import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Grid = styled.div`
    margin: 0 0.5rem;
    @media screen and (min-width: 750px) {
        display: grid;
        grid-gap: 0 2.25em;
        grid-template-columns: repeat(12, 1fr);
        margin: 0 auto;
        width: 90%;
    }
    @media screen and (min-width: 1280px) {
        grid-gap: 0 3em;
        width: 50rem;
    }
`
const Column = styled.div`
    display: ${props => props.centered ? 'flex' : 'block' };
    flex-direction: column;
    justify-content: ${props => props.top
        ? 'flex-start'
        : 'center'
    };
    align-items: center;
    grid-column: span ${props=> props.span || 1};
`
export { Grid, Column }


// WEBPACK FOOTER //
// ./src/components/grid.js